__turbopack_context__.v({
  "links": "menu-links-module-scss-module__74M9-G__links",
});
